export enum VectorType {
  path = <any>'path',
  line = <any>'line',
  rect = <any>'rect',
  circle = <any>'circle',
  ellipse = <any>'ellipse',
  text = <any>'text'
}
